import React, { useEffect, useState } from 'react';
import './PageContent.style.scss';
// import '../../../assets/CSS/bootstrap-5-48-FBX.css';
import OneLiner from '../OneLinerComponents/OneLiner/OneLiner.component'
import ScoutOneLiner from '../OneLinerComponents/ScoutOneLiner/scoutOneLiner.component.jsx';
import NoteOneLiner from '../OneLinerComponents/NoteOneLiner/noteOneLiner.component.jsx';

import { useAllThingsLists } from '../../../Contexts/allThingsList.context';
import { useDataLayer } from '../../../Contexts/DataLayer.context';
import { usePlayer } from '../../../Contexts/playerData.context';
import { useNavBar } from '../../../Contexts/navbar.items.context.jsx';

import { getMyScouts } from '../../../utils/functions.ts';
import { getNipList, getUserFromToken } from '../../../utils/functions.ts';
import { LoadUFL24 } from "../../../utils/loadFunctions.ts"

const isQuickListName = (name) => ["-QUICKLIST-", "-QUICK LIST-"].includes(String(name ?? "").trim());

const PageContent = () => {

    const { updateFilterBoxDropdown, updateFilterBoxValue, isListFiltered, filterBoxValue, filterBoxDropdown, updateQuickList, updateQuickListNumbers, updateIsListFiltered, setIsListPillFiltered } = useAllThingsLists();
    const { listArray, scoutArray, updateScoutArray, whichOneLiner } = useDataLayer();
    const { playerData, originalPlayerData, setPlayerData, playerID, setPlayerID, listLoadID, setPlayerDataLength, setActiveFilter, activeFilter, setActivePlayer, activePlayer, pendingRosterFilter } = usePlayer();
    const { updateNip, updateUSA, updateGlo, updateV } = useNavBar();
    const safePlayerData = Array.isArray(playerData) ? playerData : [];
    const safeOriginalPlayerData = Array.isArray(originalPlayerData) ? originalPlayerData : [];

    const [tempPlayerID, setTempPlayerID] = useState(null);




    useEffect(() => {
        const fetchScouts = async () => {
            if (scoutArray.length === 0) {
                try {
                    const user = await getUserFromToken();
                    if (!user) return;
                    const scoutList = await getMyScouts(user.scout, user.team);
                    updateScoutArray(scoutList);
                } catch (error) {
                }
            }
        };
        fetchScouts();
        LoadUFL24().catch((e) => console.error("LoadUFL24 on mount:", e));
        // LoadUFL24();
        // eslint-disable-next-line 
    }, []);

    const toggleImpNipFilter = (value) => {
        console.log("Toggling ImpNip Filter with value:", value);
        // if (originalPlayers || originalPlayers.length === 0) return;

        if (!value) {
            setPlayerData(safeOriginalPlayerData);
            return
        }

        let filteredPlayers = safeOriginalPlayerData.filter(player => {
            if (value === 'V') return player.impnip.startsWith("V");
            if (value === 'N' || value === 'G') return player.impnip === value;
            return ["", "-", " ", "U"].includes(player.impnip);
        });
        let findID = activePlayer?.FBXID || null;
        if (findID) {
            let existsInFiltered = filteredPlayers.some(player => player.FBXID === findID);
            if (!existsInFiltered) {
                setPlayerID(filteredPlayers[0]?.FBXID || null);
                setActivePlayer(filteredPlayers[0] || null);
            } else {
                setPlayerID(activePlayer?.FBXID || null);
            }
        }
        setPlayerData(filteredPlayers);
    };

    useEffect(() => {
        toggleImpNipFilter(activeFilter);
    }, [activeFilter]);


    useEffect(() => {
        if (filterBoxValue.trim() === "") {
            if (activeFilter) {
                toggleImpNipFilter(activeFilter);
                return;
            }
            setPlayerData(safeOriginalPlayerData); // ✅ Restore full list
            return;
        }

        const searchValue = filterBoxValue.toLowerCase();
        let field = filterBoxDropdown; // This should be dynamic based on the selected field

        const allFields = ["last", "first", "note", "genPos", "school", "cflTeam", "nflTeam", "optionYr", "ufl24Team"];
        const filteredPlayers = safeOriginalPlayerData.filter(player => {
            if (field === "LN") return player.last?.toLowerCase().includes(searchValue);
            if (field === "FN") return player.first?.toLowerCase().includes(searchValue);
            if (field === "NT") return player.note?.toLowerCase().includes(searchValue);
            if (field === "GEN") return player.genPos?.toLowerCase().includes(searchValue);
            if (field === "SCH") return player.school?.toLowerCase().includes(searchValue);
            if (field === "CFL") return player.cflTeam?.toLowerCase().includes(searchValue);
            if (field === "NFL") return player.nflTeam?.toLowerCase().includes(searchValue);
            if (field === "FCY") return player.optionYr?.toString().toLowerCase().includes(searchValue);
            if (field === "UFL24") return player.ufl24Team?.toLowerCase().includes(searchValue);
            if (field === "EXP") return player.exposure?.toLowerCase().includes(searchValue);
            if (field === "GR") return !isNaN(Number(searchValue)) && Number(player.masterGrade) >= Number(searchValue);
            if (field === "CGR") return !isNaN(Number(searchValue)) && Number(player.calculated) >= Number(searchValue);
            if (field === "All") {
                return allFields.some(fieldName => {
                    const value = player[fieldName]; // Get the field value
                    return typeof value === "string" && value.toLowerCase().includes(searchValue);
                });
            }

            return false;
        });
        setPlayerData(filteredPlayers); // ✅ Apply filtered data
    }, [filterBoxValue]);


    useEffect(() => {
        // Ensure listArray is loaded and contains data
        if (listArray && listArray.length > 0) {
            const newQuickList = listArray.find(item => item.listName === '-QUICKLIST-')
                || listArray.find(item => isQuickListName(item.listName));
            if (newQuickList) {
                updateQuickList(newQuickList);
                updateQuickListNumbers(newQuickList.theNumbers);
            }
        }
        // eslint-disable-next-line
    }, [listArray]);

    useEffect(() => {
        const fetchNipList = async () => {
            const stringer = await getNipList(safePlayerData);
            const arrayOfStrings = stringer.split(",");
            updateNip(arrayOfStrings[0]);
            updateUSA(arrayOfStrings[1]);
            updateGlo(arrayOfStrings[2]);
            updateV(arrayOfStrings[3]);
        };
        setPlayerDataLength(safePlayerData.length);
        setPlayerID(playerID);
        if (safePlayerData.length > 0 && !isListFiltered && !activeFilter) {
            fetchNipList();
        }

        // eslint-disable-next-line 
    }, [playerData])


    useEffect(() => {
        if (safePlayerData.length === 0 && pendingRosterFilter.current === null) {
            console.warn("Waiting for playerData to be populated...");
            return; // ✅ Exit useEffect if playerData is empty
        }

        updateFilterBoxValue('');
        updateFilterBoxDropdown('All');
        updateIsListFiltered(false);
        const rosterFilter = pendingRosterFilter.current;
        pendingRosterFilter.current = null;
        setIsListPillFiltered(Boolean(rosterFilter));
        setActiveFilter(rosterFilter || '');
        if (rosterFilter !== null) toggleImpNipFilter(rosterFilter);

        const fetchNipList = async () => {
            const stringer = await getNipList(safePlayerData);
            const arrayOfStrings = stringer.split(",");
            updateNip(arrayOfStrings[0]);
            updateUSA(arrayOfStrings[1]);
            updateGlo(arrayOfStrings[2]);
            updateV(arrayOfStrings[3]);
        };

        fetchNipList();
    }, [listLoadID]); // ✅ Also depend on `playerData`



    return (
        <div>
            <div>
                {!whichOneLiner && safePlayerData.length > 0 && <OneLiner />}
                {whichOneLiner === 'Scout' && safePlayerData.length > 0 && <ScoutOneLiner />}
                {whichOneLiner === 'Note' && safePlayerData.length > 0 && <NoteOneLiner />}
            </div>
        </div>
    );

}
export default PageContent;
